module.exports = __webpack_public_path__ + "static/media/CM pragati yatra without shadow.acffe64e.svg";